/***
 *
 *   SWITCH STYLES
 *   The reference has no switch — it uses checkboxes throughout — so this is
 *   a judgement call: standard switch proportions (36x20 track, 16px handle)
 *   on the reference's tokens and its 150ms transition.
 *
 **********/

const Style = {
    switch: 'relative mb-4 flex w-full items-start gap-3',
    track: 'relative mt-0.5 h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-150 ease-out',
    trackOn: 'bg-primary-600',
    trackOff: 'border border-border bg-muted',
    handle: `pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 rounded-full bg-surface shadow-sm
    transition-[left] duration-150 ease-out`,
    handleOff: 'left-0.5',
    handleOn: 'left-[1.125rem]',
    labelWrap: 'min-w-0 flex-1',
    label: 'cursor-pointer text-sm font-medium normal-case text-text-primary',
    hint: 'mt-0.5 text-xs leading-relaxed text-text-muted',
};

export default Style;
